import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Tabs,
  TabList,
  useColorModeValue,
  Button,
  Flex,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  VStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { FaPrint, FaSync } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Exam = () => {
  const [examList, setExamList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  useEffect(() => {
    // Fetch the exam list from the API
    const fetchExams = async () => {
      try {
        const userId = sessionStorage.getItem("user_id"); // Retrieve user ID from session
        const response = await axios.post(
          `${BASE_URL}/student/list_exams.php`,
          { pass: userId }
        );
        console.log("list exam",response);
        

        if (response.data.success) {
          const filteredDetails = response.data.data.filter(
            (detail) => detail.academic_year_id === academicId
          );
          console.log("fil",filteredDetails);
          
          setExamList(filteredDetails);
          const uniqueCategories = [
            ...new Set(filteredDetails.map((exam) => exam.category)),
          ]; // Extract unique categories
          setCategories(uniqueCategories);
        }
      } catch (error) {
        console.error("Error fetching exam list:", error);
      }
    };

    fetchExams();
  }, [academicId]);

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Details</h1>
          <div className="action-buttons">
            {/* <Button className="refresh-button" display={{ base: 'none', md: 'flex' }}
              boxShadow="md" backgroundColor='white' fontSize='11px' onClick={() => { console.log('Refresh button clicked'); }}>
              <FaSync color='#515B73' />
            </Button> */}
            <div className="export-dropdown">
              {/* <Button className="export-button" display={{ base: 'none', md: 'flex' }}
                backgroundColor='white' fontSize='11px' boxShadow="md">
                <FaPrint color='#515B73' />
                Print PDF
              </Button> */}
            </div>
          </div>
        </div>
        <div className="breadcrumb">
          <span>Student</span> / <span>Exam</span> / <span>Exam Details</span>
        </div>
      </div>
      <Box p={6}>
        <VStack spacing={4} align="stretch">
          <Tabs
            variant="soft-rounded"
            colorScheme="teal"
            isFitted
            p={2}
            borderRadius="md"
            bg={useColorModeValue("white", "gray.700")}
          >
            <TabList>
              {categories.map((category) => (
                <Tab
                  key={category}
                  _selected={{
                    bg: "teal.100",
                    color: "teal.800",
                    fontWeight: "bold",
                    borderRadius: "md",
                  }}
                  py={2}
                >
                  {category}
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              {categories.map((category) => (
                <TabPanel key={category} p={4}>
                  <Box overflowX="auto" maxWidth="100%">
                    <Table
                      sx={{
                        "tbody tr:nth-of-type(even)": {
                          backgroundColor: "#f2f4f8",
                        },
                      }}
                    >
                      <Thead>
                        <Tr>
                          <Th>Subject</Th>
                          <Th>Exam Date</Th>
                          <Th>Max Marks</Th>
                          <Th>Pass Marks</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {examList
                          .filter((exam) => exam.category === category)
                          .map((exam) => (
                            <Tr key={exam.id}>
                              <Td>{exam.subject}</Td>
                              <Td>{exam.exam_date}</Td>
                              <Td>{exam.max_marks}</Td>
                              <Td>{exam.pass_marks}</Td>
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </Box>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </VStack>
      </Box>
    </div>
  );
};

export default Exam;
